import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { ViewLogsDashboard } from "./ViewLogsDashboard";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

/** Modal shell around `ViewLogsDashboard`; data loading lives in the dashboard. */
const ViewLogsModal = ({ open, onClose, interviewId, candidateName }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" scroll="paper">
    <DialogTitle sx={{ fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>View Logs
      <Button variant="outlined" color="secondary" size="small" onClick={onClose}>Close
        <CloseRoundedIcon fontSize="small" />
      </Button>
    </DialogTitle>
    <DialogContent dividers>
      <ViewLogsDashboard active={open} interviewId={interviewId} candidateName={candidateName} />
    </DialogContent>
  </Dialog>
);
  
export default ViewLogsModal;
